import webApiAdmin from '@/lib/api-common/webApiAdmin';
import { createCachedApi } from '@/lib/utils/indexedDbCache';
import { getNewApiBaseUrl } from '@/lib/api-common/config';

export interface CampaignResult {
  _id?: string;
  [key: string]: unknown;
}

/* ── 캐싱된 loadResults ── */
const cachedResults = createCachedApi<CampaignResult[]>({
  prefix: 'statsV2.loadResults::',
  // - Legacy: POST /api3/statsV2/loadResults
  // - New:    POST /admin/stats-v2/results/load
  fetcher: () => webApiAdmin.post<CampaignResult[]>('admin/stats-v2/results/load', {}),
  normalize: (data) => (Array.isArray(data) ? data : []),
  shouldCache: (data) => data.length > 0,
  // Single "everything" key → eligible for proactive warming (warmHeavyCaches).
  warmParams: [{}],
});

export const RESULTS_CACHE_KEY_PREFIX = cachedResults.CACHE_KEY_PREFIX;
export const loadResults = cachedResults.fetch;
export const clearResultsCache = cachedResults.clear;

/**
 * Refresh one campaign's result.
 * - Legacy: POST /api3/statsV2/refreshResult
 * - New:    POST /admin/stats-v2/results/refresh
 */
export async function refreshResult(campaignId: string): Promise<CampaignResult> {
  const data = await webApiAdmin.post<CampaignResult>('admin/stats-v2/results/refresh', { campaignId });
  await clearResultsCache();
  return data ?? ({} as CampaignResult);
}

/**
 * Returns the URL for the campaign results Excel download.
 * - Legacy: GET /api3/results/excel/?timezone=<tz>
 * - New:    GET /admin/campaign-results/excel?timezone=<tz>
 *
 * Used with ExcelDownloadButton (anchor click) rather than a programmatic fetch,
 * because the response is a binary file stream, not a JSON envelope.
 */
export function getResultsExcelUrl(timezone: string): string {
  const tz = encodeURIComponent(timezone);
  return `${getNewApiBaseUrl()}/admin/campaign-results/excel?timezone=${tz}`;
}
